/**
 * Storage Settings Page
 * 
 * Standalone page wrapper for StorageSettingsSection.
 * Admin-only — gated by SettingsLayout visibility.
 */

import { StorageSettingsSection } from '@/features/system';

export function StoragePage() {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Storage Settings
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">
          Monitor and manage platform storage configuration
        </p>
      </div>

      <div className="max-w-2xl">
        <StorageSettingsSection />
      </div>
    </div>
  );
}
